<template>
  <b-server-autocomplete
    v-model="data.executorId"
    :error-messages="getErrorMessages(v$.executorId)"
    :url="urlAllUsers()"
    hide-details
    item-title="name"
    item-value="id"
    label="Виконавець"
    placeholder="Введіть мін. 3 символи"
    @blur="v$.executorId.$touch()" />
</template>

<script>
import { reactive } from 'vue'
import { getErrorMessages } from 'best-modules/utils'
import { fillDirectory } from '@/directory'
import { required, useVuelidate } from '@/plugins'
import { urlAllUsers } from '@/utils/urls'
import { setSnackbar } from 'best-modules/plugins'
import { BServerAutocomplete } from 'best-modules/components'
import { taskCopy } from '@/requests/task'

export default {
  name: 'CopyTask',
  components: {
    BServerAutocomplete,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { urlAllUsers, getErrorMessages },
  async setup(props) {
    await fillDirectory(['userList'])
    const data = reactive({
      executorId: null,
    })

    const v$ = useVuelidate(
      {
        executorId: { required },
      },
      data
    )

    const submit = () => {
      return taskCopy(props.dialog.dialogData.taskId, data?.executorId).then(
        res => {
          setSnackbar({ text: 'Завдання скопійовано', color: 'success' })
          setSnackbar({
            text: 'Вас перенаправлено до скопіюваного завдання',
            color: 'warning',
          })
          return res
        }
      )
    }

    return {
      v$,
      data,
      submit,
    }
  },
}
</script>

<style lang="scss" scoped></style>
